export default __webpack_public_path__ + "static/media/ReportLightInActive.bdedb83c.svg";